module.exports = __webpack_public_path__ + "img/choose-img.6f94ff0c.png";